import Resource from './Resource';

class BusinessEmail extends Resource {
	eventName: string;

	constructor() {
		super('businessEmail');

		// templateParser.js subscribes to 'businessEmail.added' to refetch the invalid-domain list
		// into the live form preview, so this event is load-bearing.
		this.eventName = 'businessEmail';

		this.notifications = {
			save: () => ({
				title: 'default.saved',
				body: 'saved.businessEmail',
				style: 'success',
				icon: 'check',
				type: 'body'
			}),
			saveError: () => ({
				title: 'default.error',
				body: 'saveError.businessEmail',
				style: 'error',
				icon: 'times',
				type: 'body'
			})
		} as any;
	}

	getScript(): Promise<string> {
		return this._getRequest('be', { _url: 'master/script', methodName: 'getScript' }).then(res => res.data.data);
	}
}

export default new BusinessEmail();
